"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mycotoxinColumnsFactory = exports.chemResColumnsFactory = void 0;
var index_1 = require("../index");
var chemResColumnsFactory = function (_a) {
    var _b = _a.addPassFail, addPassFail = _b === void 0 ? false : _b;
    return __spreadArrays([
        index_1.AnalyteColumn,
        index_1.LODColumnFactory(),
        index_1.LOQColumnFactory(),
        index_1.ActionLimitsColumnFactory({
            solidDisplayUnits: "ug/g",
            volumeDisplayUnits: "ug/mL",
        }),
        index_1.DefaultResultsColumnFactory({ analyteProp: "analyte", precision: 3 })
    ], (addPassFail
        ? [
            __assign(__assign({}, index_1.PassFailColumn), { accessor: function (row) {
                    return index_1.determineRowPassFail("analyte")(row);
                } }),
        ]
        : []));
};
exports.chemResColumnsFactory = chemResColumnsFactory;
var mycotoxinColumnsFactory = function (_a) {
    var _b = _a.addPassFail, addPassFail = _b === void 0 ? false : _b;
    return __spreadArrays([
        index_1.AnalyteColumn,
        index_1.LODColumnFactory({
            solidDisplayUnits: "ug/kg",
            volumeDisplayUnits: "ug/L",
            precision: 3,
        }),
        index_1.LOQColumnFactory({
            solidDisplayUnits: "ug/kg",
            volumeDisplayUnits: "ug/L",
            precision: 3,
        }),
        index_1.ActionLimitsColumnFactory({
            solidDisplayUnits: "ug/kg",
            volumeDisplayUnits: "ug/L",
        }),
        index_1.DefaultResultsColumnFactory({
            analyteProp: "analyte",
            precision: 2,
            solidDisplayUnits: "ug/kg",
            volumeDisplayUnits: "ug/L",
        })
    ], (addPassFail
        ? [
            __assign(__assign({}, index_1.PassFailColumn), { accessor: function (row) {
                    return index_1.determineRowPassFail("analyte")(row);
                } }),
        ]
        : []));
};
exports.mycotoxinColumnsFactory = mycotoxinColumnsFactory;
//# sourceMappingURL=columns.js.map